import { Tag, Tooltip } from 'antd';
import { FC } from 'react';
import { ClientSearchResult } from '../../hooks/useClientsSearch';
import { contract_badges } from '../../model/capabilities';

interface IProps {
	client: ClientSearchResult;
}

export const CapabilityBadges: FC<IProps> = ({ client }) => {
	const badges = contract_badges(client.capabilities || []);

	if (badges.length === 0) {
		return <span style={{ color: '#bfbfbf' }}>—</span>;
	}

	const now = Date.now();

	return (
		<div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
			{badges.map(([key, badge]) => {
				const end_at = badge.expiry_field ? client[badge.expiry_field] : undefined;
				const expired = typeof end_at === 'number' && end_at > 0 && end_at < now;

				const tag = (
					<Tag
						key={key}
						color={expired ? undefined : badge.color}
						style={{
							margin: 0,
							borderRadius: 4,
							fontSize: 11,
							lineHeight: '18px',
							...(expired
								? {
										background: '#fff',
										color: badge.color,
										borderColor: badge.color,
										borderStyle: 'dashed',
								  }
								: { border: 'none' }),
						}}
					>
						{badge.label}
						{expired ? ' · vencido' : ''}
					</Tag>
				);

				if (!expired) {
					return tag;
				}

				return (
					<Tooltip
						key={key}
						title={`Contrato de ${badge.label.toLowerCase()} vencido em ${new Date(
							end_at as number
						).toLocaleDateString('pt-BR')}`}
					>
						{tag}
					</Tooltip>
				);
			})}
		</div>
	);
};
